import Vue from 'vue';

export default {
  state: {
    tendersPage: {},
    tendersList: [],
    tendersCategories: [],
  },
  getters: {
    getFilteredTendersList: (state) => (categoryId) => state.tendersList
      .filter((item) => item.tenders_category.id === categoryId),
  },
  mutations: {
    setTendersPage(state, data) {
      state.tendersPage = data;
    },
    setTendersList(state, data) {
      state.tendersList = data;
    },
    setTendersCategories(state, data) {
      state.tendersCategories = data;
    },
  },
  actions: {
    getTendersPage(store) {
      const path = 'tenders-page';
      return Vue.prototype.$axios.get(path).then((resp) => {
        store.commit('setTendersPage', resp.data);
        return resp.data;
      });
    },
    getTendersCategories(store) {
      const path = 'tenders-categories';
      return Vue.prototype.$axios.get(path).then((resp) => {
        store.commit('setTendersCategories', resp.data);
        return resp.data;
      });
    },
    getTendersList(store) {
      const path = 'tenders';
      return Vue.prototype.$axios.get(path).then((resp) => {
        store.commit('setTendersList', resp.data);
        return resp.data;
      });
    },
  },
};
